import { useEffect, useMemo, useState } from "react";
import client from "../../helpers/Client";
import {
  FormControl,
  FormLabel,
  Input,
  Select,
  Checkbox,
  RadioGroup,
  Radio,
  Stack,
  Box,
} from "@chakra-ui/react";

export default function UserPicker({
  resellerID,
  value,
  onChange,
}) {
  const [teams, setTeams] = useState([]);
  const [employees, setEmployees] = useState([]);
  const [query, setQuery] = useState("");
  const [teamFilter, setTeamFilter] = useState("");
  const [onlyManagers, setOnlyManagers] = useState(false);
  useEffect(() => {
    if (!resellerID) return;
    client
      .get("/teams/", { params: { reseller: resellerID } })
      .then((r) => setTeams(r.data || []))
      .catch(() => setTeams([]));
  }, [resellerID]);
  useEffect(() => {
    if (!resellerID) return;
    const params = { reseller: resellerID };
    if (teamFilter) params.teams = teamFilter;
    if (onlyManagers) params.is_manager = true;
    client
      .get("/employees/", { params })
      .then((r) => setEmployees(r.data || []))
      .catch(() => setEmployees([]));
  }, [resellerID, teamFilter, onlyManagers]);
  const filtered = useMemo(() => {
    const q = query.trim().toLowerCase();
    if (!q) return employees;
    return employees.filter((e) => {
      const u = e.user || {};
      const name = `${u.first_name || ""} ${u.last_name || ""}`.trim();
      const uname = u.username || "";
      return (
        name.toLowerCase().includes(q) ||
        uname.toLowerCase().includes(q)
      );
    });
  }, [employees, query]);
  return (
    <Box display="flex" flexDirection="column" gap={3}>
      <FormControl>
        <FormLabel>Arama</FormLabel>
        <Input value={query} onChange={(e) => setQuery(e.target.value)} placeholder="Ad, soyad veya kullanıcı adı" />
      </FormControl>
      <FormControl>
        <FormLabel>Takım</FormLabel>
        <Select value={teamFilter} onChange={(e) => setTeamFilter(e.target.value)}>
          <option value="">Tümü</option>
          {teams.map((t) => (
            <option key={t.url} value={t.url}>{t.name}</option>
          ))}
        </Select>
      </FormControl>
      <Checkbox isChecked={onlyManagers} onChange={(e) => setOnlyManagers(e.target.checked)}>Sadece yöneticiler</Checkbox>
      <FormControl>
        <FormLabel>Kullanıcı</FormLabel>
        <RadioGroup value={value || ""} onChange={onChange}>
          <Stack direction="column" spacing={2} maxH="260px" overflowY="auto" borderWidth="1px" borderRadius="md" p={2}>
            <Radio value="">Seçilmemiş</Radio>
            {filtered.map((e) => {
              const u = e.user || {};
              const name = `${u.first_name || ""} ${u.last_name || ""}`.trim() || u.username;
              const badge = e.is_manager ? " (Yönetici)" : "";
              const reseller = e.reseller?.name ? ` - ${e.reseller.name}` : "";
              return (
                <Radio key={u.url} value={u.url}>
                  {name}{badge}{reseller}
                </Radio>
              );
            })}
          </Stack>
        </RadioGroup>
      </FormControl>
    </Box>
  );
}
